import { emptyCustomFieldsByTab } from '@/vacancy_request/components/template-request-form/custom-fields/constants';

export const optionsValues = {
  OPTIONAL: 2,
  REQUIRED: 1,
  DISABLED: 0
};

/**
 * Nivel por defecto de un campo custom recién agregado. No arranca deshabilitado: si el admin
 * se tomó el trabajo de crearlo, el default razonable es que se muestre en el formulario.
 */
export const DEFAULT_CUSTOM_FIELD_REQUIRED = optionsValues.OPTIONAL.toString();

export const optionsList = [
  { value: optionsValues.DISABLED.toString(), label: 'Deshabilitado', traduction: 'unavailable' },
  { value: optionsValues.OPTIONAL.toString(), label: 'Opcional', traduction: 'optional' },
  { value: optionsValues.REQUIRED.toString(), label: 'Obligatorio', traduction: 'mandatory' }
];

export const defaultFormValues = {
  // Tab-1
  template_name: '',
  templatePortalData: '',
  templatePortalDataName: '',
  applicantName: optionsValues.REQUIRED.toString(),
  applicantEmail: optionsValues.REQUIRED.toString(),
  area: optionsValues.REQUIRED.toString(),
  areaApprovalRequired: false,
  templateAreaId: '',
  templateClientId: '',
  templateSubareaId: '',
  subarea: optionsValues.DISABLED.toString(),
  subareaApprovalRequired: false,
  country: optionsValues.DISABLED.toString(),
  zona: optionsValues.DISABLED.toString(),
  locality: optionsValues.DISABLED.toString(),
  // Tab-2
  name: optionsValues.REQUIRED.toString(),
  c_area: optionsValues.DISABLED.toString(),
  c_subarea: optionsValues.DISABLED.toString(),
  c_modality: optionsValues.DISABLED.toString(),
  search_reason: optionsValues.DISABLED.toString(),
  count_post: optionsValues.DISABLED.toString(),
  c_type_jobs: optionsValues.DISABLED.toString(),
  apto_discapacitados: optionsValues.DISABLED.toString(),
  // Tab-3
  experience: optionsValues.DISABLED.toString(),
  c_hierarchy: optionsValues.DISABLED.toString(),
  selectedLanguages: optionsValues.DISABLED.toString(),
  hasPeopleInCharge: optionsValues.DISABLED.toString(),
  travel_availability: optionsValues.DISABLED.toString(),
  requirements: optionsValues.DISABLED.toString(),
  benefits: optionsValues.DISABLED.toString(),
  attachedFile: optionsValues.OPTIONAL.toString(),
  // Campos custom, un array por pestaña. Ver custom-fields/custom-fields-section.jsx.
  customFields: emptyCustomFieldsByTab()
};
